/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IRepoUploadVerificationFinishedSubscriptionVariables = Types.Exact<{
  assetId: Types.Scalars['ID']['input'];
}>;

export type IRepoUploadVerificationFinishedSubscription = {
  __typename?: 'Subscription';
  repoUploadVerificationFinished?: {
    __typename?: 'RepoUploadVerificationResult';
    success: boolean;
    error?: string | null;
    asset: {
      __typename?: 'Asset';
      id: string;
      syncStatus?: Types.SyncStatusEnum | null;
      depositStatus: Types.DepositStatusEnum;
      size?: any | null;
      error?: string | null;
      updatedAt: any;
    };
  } | null;
};

export const RepoUploadVerificationFinishedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'RepoUploadVerificationFinished' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repoUploadVerificationFinished' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'syncStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IRepoUploadVerificationFinishedSubscription,
  IRepoUploadVerificationFinishedSubscriptionVariables
>;
